export const PAGE_RELAYOUT_EVENT = 'PAGE_RELAYOUT_EVENT';
export function triggerCustomEvent(name, props) {
  let customEvent;
  if (typeof CustomEvent === 'function') {
    // This will handle modern browsers
    customEvent = new CustomEvent(name, props);
  } else {
    // This will handle IE
    customEvent = window.document.createEvent('UIEvents');
    customEvent.initUIEvent(name, true, false, window, 0);
  }
  window.dispatchEvent(customEvent);
}

export function triggerResizeEvent() {
  triggerCustomEvent('resize');
}
